import NonAuthLayout from "components/NonAuthLayout"
import AuthCodeForm from "pages/AuthCodeForm"
import React from "react"
import { Route, Redirect } from "react-router-dom"
import Login from "../pages/Login"

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  token,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (localStorage.getItem("user")) {
        if (token) {
          if (localStorage.getItem("permissions").includes(token)) {
            return (
              <Layout>
                <Component {...props} />
              </Layout>
            )
          } else {
            return (
              <Redirect
                to={{ pathname: "/home", state: { from: props.location } }}
              />
            )
          }
        } else {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          )
        }
      } else {
        if (props.location.pathname === "/login") {
          localStorage.removeItem('token')
          return (
            <NonAuthLayout>
              <Login />
            </NonAuthLayout>
          )
        }else if (props.location.pathname === "/auth-code") {
          return (
            <NonAuthLayout>
              <AuthCodeForm />
            </NonAuthLayout>
          )
        } else {
          localStorage.removeItem('token')

          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }
      }
    }}
  />
)

export default Authmiddleware
